import React, { useState, useEffect } from "react";
import {
  getFirestore,
  collection,
  onSnapshot,
  addDoc,
} from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";

import "./styles/importProducts.css";

function ImportProducts() {
  const { collectionName, receivingCollection } = useParams();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const db = getFirestore();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, collectionName),
      (snapshot) => {
        const data = [];
        snapshot.forEach((doc) => {
          data.push({ id: doc.id, ...doc.data() });
        });
        setProducts(data);
        setFilteredProducts(data);
      }
    );

    return () => unsubscribe();
  }, [db, collectionName]);

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredProducts(products);
    } else {
      setFilteredProducts(
        products.filter((product) =>
          product.productTitle.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }
  }, [searchQuery, products]);

  const handleSelectProduct = (product) => {
    if (selectedProducts.includes(product)) {
      setSelectedProducts(selectedProducts.filter((p) => p.id !== product.id));
    } else {
      setSelectedProducts([...selectedProducts, product]);
    }
  };

  const handleImportProducts = async () => {
    const targetCollection = collection(db, receivingCollection);

    for (const product of selectedProducts) {
      const productData = {
        productTitle: product.productTitle,
        productDescription: product.productDescription,
        productPrice: product.productPrice,
        productImage: product.productImage,
        inStock: product.inStock,
      };

      if (product.oldPrice !== undefined) {
        productData.oldPrice = product.oldPrice;
      }

      await addDoc(targetCollection, productData);
    }

    navigate(-1);
  };

  const handleSelectAll = () => {
    setSelectedProducts(filteredProducts);
  };

  const handleUnselectAll = () => {
    setSelectedProducts([]);
  };

  function formatString(str) {
    const words = str.replace(/([A-Z])/g, " $1").trim();
    return words.charAt(0).toUpperCase() + words.slice(1);
  }

  return (
    <div className="import-products-container">
      <h2 className="header">
        Import Products from {formatString(collectionName)}
      </h2>
      <div className="toolbar">
        <div className="left-toolbar">
          <button
            className="btn btn-danger select-button"
            onClick={handleUnselectAll}
          >
            Unselect All
          </button>
          <button
            className="btn btn-primary select-button"
            onClick={handleSelectAll}
          >
            Select All
          </button>
        </div>
        <div className="search-bar">
          <input
            className="form-control"
            type="text"
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="right-toolbar">
          <button
            className="import-button fw-bold"
            onClick={handleImportProducts}
            disabled={selectedProducts.length === 0}
          >
            Import Selected Products
          </button>
        </div>
      </div>
      <ul className="product-list">
        {filteredProducts.map((product) => (
          <label
            htmlFor={"productCheck" + product.id}
            role="button"
            key={product.id}
          >
            <li className="product-item">
              <div className="product-info">
                <img
                  src={product.productImage}
                  alt={product.productTitle}
                  className="product-image"
                />
                <span className="product-title">{product.productTitle}</span>
              </div>
              <input
                className="form-check-input fs-4"
                type="checkbox"
                checked={selectedProducts.includes(product)}
                onChange={() => handleSelectProduct(product)}
                id={"productCheck" + product.id}
              />
            </li>
          </label>
        ))}
      </ul>
      <button
        className="import-button fw-bold"
        onClick={handleImportProducts}
        disabled={selectedProducts.length === 0}
      >
        Import Selected Products
      </button>
    </div>
  );
}

export default ImportProducts;
